import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import enquiryService from "./enquiryService";
import { toast } from 'react-toastify';

export const getEnquiries = createAsyncThunk(
  "enquiry/get-enquiries",
  async (thunkAPI) => {
    try {
      return await enquiryService.getEnquiries();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAEnquiry = createAsyncThunk(
  "enquiry/delete-enquiry",
  async (id, thunkAPI) => {
    try {
      return await enquiryService.deleteEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getAEnquiry = createAsyncThunk(
  "enquiry/get-enquiry",
  async (id, thunkAPI) => {
    try {
      return await enquiryService.getEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAEnquiry = createAsyncThunk(
  "enquiry/update-enquiry",
  async (enq, thunkAPI) => {
    try {
      return await enquiryService.udpateEnquiry(enq);
    } catch (error) {
      // Extract serializable parts of the Axios error
      const serializableError = {
        message: error.message,
        code: error.code,
        response: error.response ? error.response.data : null,
      };
      return thunkAPI.rejectWithValue(serializableError);
    }
  }
);

export const getUnreadEnquiries = createAsyncThunk(
  "enquiry/get-unread-enquiries",
  async (_, thunkAPI) => {
    try {
      return await enquiryService.getUnreadEnquiries();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);



export const markEnquiryAsRead = createAsyncThunk(
  "enquiry/markAsRead",
  async (id, thunkAPI) => {
    try {
      return await enquiryService.markEnquiryAsRead(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);





export const submitFeedback = createAsyncThunk(
  "enquiry/submit-feedback",
  async ({ id, email,userName,originalComment, feedback, staffMember }, thunkAPI) => {
    try {
      return await enquiryService.submitFeedback({ id, email,userName,originalComment, feedback, staffMember });
    } catch (error) {
      const serializableError = {
        message: error.message,
        code: error.code,
        response: error.response ? error.response.data : null,
      };
      return thunkAPI.rejectWithValue(serializableError);
    }
  }
);


export const resetState = createAction("Reset_all");

const initialState = {
  enquiries: [],
  
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const enquirySlice = createSlice({
  name: "enquiries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEnquiries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEnquiries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enquiries = action.payload;
      })
      .addCase(getEnquiries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEnquiry = action.payload;
      })
      .addCase(deleteAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enqName = action.payload.name;
        state.enqMobile = action.payload.mobile;
        state.enqEmail = action.payload.email;
        state.enqComment = action.payload.comment;
        state.enqStatus = action.payload.status;
      })
      .addCase(getAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedEnquiry = action.payload;
      })
      .addCase(updateAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getUnreadEnquiries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnreadEnquiries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.unreadEnquiries = action.payload.enquiries;
      })
      .addCase(getUnreadEnquiries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error.message || "Failed to fetch unread enquiries";
      })
      .addCase(markEnquiryAsRead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markEnquiryAsRead.fulfilled, (state) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.message = "Enquiry marked as read successfully";
      })
      .addCase(markEnquiryAsRead.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message || "Failed to mark enquiry as read";
        state.isLoading = false;
      })
      .addCase(submitFeedback.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(submitFeedback.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.feedbackResponse = action.payload;
        toast.success('Feedback sent successfully!'); 
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default enquirySlice.reducer;
